import { Loading } from '../../components';
import { IsAccessTokenValidQuery, useReportAccessQuery } from '../../generated/hooks';
import { getReportAccesses } from '../../graphql/queries';
import { ReportAccessTable } from '../ReportAccess/ReportAccessTable';
import { getShowReportOpenIcon } from '../ReportAccess/utils';

interface IProps {
  surveyId: number;
  user: NonNullable<IsAccessTokenValidQuery['isAccessTokenValid']['user']>;
}

const SurveyReportAccess = ({ surveyId, user }: IProps) => {
  const { loading, data } = useReportAccessQuery({
    variables: {
      surveyId: surveyId.toString(),
    },
    fetchPolicy: 'no-cache',
  });

  const dependantQueries = [
    {
      query: getReportAccesses,
      variables: { surveyId },
    },
  ];

  if (loading) {
    return <Loading />;
  }

  return (
    <ReportAccessTable
      dependantQueries={dependantQueries}
      showOpenIcon={getShowReportOpenIcon(data?.survey?.sendAt)}
      surveys={data?.survey ? [data.survey] : []}
      user={user}
    />
  );
};

export default SurveyReportAccess;
